export const ELEMENT_PROPORTIONAL_DEFAULT_WIDTHS = [25, 50, 75, 100];
export const PROPORTIONAL_MIN_WIDTH = 0;
export const PROPORTIONAL_MAX_WIDTH = 100;

export const ELEMENTS_MIN_MAX_WIDTH: {
	[key: string]: {
		min: number;
		max: number;
		hideProportional?: boolean;
	};
} = {
	checkbox: { min: 5, max: 100 },
	legacyArrayView: { min: 100, max: 100 },
	textInput: { min: 5, max: 100 },
	radio: { min: 5, max: 100 },
	select: { min: 5, max: 100 },
	panel: { min: 100, max: 100 },
	date: { min: 0, max: 0, hideProportional: true },
};
